import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { SelectProps } from "../../../../shared/interfaces/select";
import Box from "@mui/material/Box";
import { useId } from "react";

const SelectAutocomplete = ({ 
  data = [], 
  error, 
  onChange, 
  value, 
  placeholder, 
  width = 300, 
  height = 55, 
  disabled = false 
}: SelectProps) => {
  const uniqueId = useId();
  
  let selectedValue = null;
  
  if (value) {
    if (typeof value === 'object' && value !== null && 'id' in value) {
      selectedValue = value;
    }
    else if (typeof value === 'string') {
      selectedValue = data.find(opt => opt.id === value || opt.value === value) || null;
    }
  }

  
  return (
    <Box sx={{ width: width }} key={`select-autocomplete-${uniqueId}`}>
      <Autocomplete
        disablePortal
        options={data}
        sx={{ 
          width: "100%", 
          height: height, 
          backgroundColor: "#fff" 
        }}
        disabled={disabled}
        isOptionEqualToValue={(option, val) => {
          if (!option || !val) return false;
          // Comparar pelos IDs
          return option.id === val.id || option.value === val.value;
        }}
        getOptionLabel={(option) => {
          if (!option) return '';
          return option.label || option.name || '';
        }}
        onChange={(_, newValue) => {
          let valueToPass = null;
          
          if (newValue) {
            // Sempre passar o ID
            valueToPass = newValue.id || newValue.value || null;
          }
          
          onChange?.(valueToPass);
        }}
        value={selectedValue}
        renderInput={(params) => (
          <TextField
            key={uniqueId}
            {...params}
            label={placeholder}
            error={!!error}
            className={`container-input__input ${
              error ? "container-input__input__error" : "container-input__input__default"
            }`}
          />
        )}
      />
      {error && <span className="container-input__input__error-message">{error.toString()}</span>}
    </Box>
  );
};

export default SelectAutocomplete;